<template>
  <div class="member-uid-header">
    <slot />
    <span class="kv">
      <span class="k">会员账号 </span>
      <span class="v">{{ username || '--' }}</span>
      <el-button type="text" icon="el-icon-copy-document" border="none" size="mini" class="copy-btn" @click="copyText(username)"></el-button>
    </span>
    <span class="kv">
      <span class="k">会员ID </span>
      <span class="v">{{ uid != null && uid !== '' ? uid : '--' }}</span>
      <el-button type="text" icon="el-icon-copy-document" size="mini" class="copy-btn" @click="copyText(String(uid ?? ''))"></el-button>
    </span>
    <span class="kv">
      <span class="k">会员等级 </span>
      <span class="v"
        ><el-tag size="mini" type="warning">{{ vipLevel != null && vipLevel !== '' ? `VIP${vipLevel}` : '--' }}</el-tag></span
      >
    </span>
  </div>
</template>

<script>
export default {
  name: 'MemberUidHeader',
  props: {
    username: {
      type: String,
      default: '',
    },
    uid: {
      type: [Number, String],
      default: null,
    },
    vipLevel: {
      type: [Number, String],
      default: 0,
    },
    tagType: {
      type: String,
      default: 'warning',
    },
  },
  methods: {
    async copyText(text) {
      const t = (text ?? '').toString()
      if (!t) return this.$message?.warning('暂无可复制内容')
      try {
        if (navigator?.clipboard?.writeText) {
          await navigator.clipboard.writeText(t)
        } else {
          const el = document.createElement('textarea')
          el.value = t
          el.setAttribute('readonly', 'readonly')
          el.style.position = 'fixed'
          el.style.left = '-9999px'
          document.body.appendChild(el)
          el.select()
          document.execCommand('copy')
          document.body.removeChild(el)
        }
        this.$message?.success('已复制')
      } catch (e) {
        this.$message?.error('复制失败')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.member-uid-header {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 16px;
  align-items: center;
  width: 100%;
}

.kv {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}

.k {
  color: #909399;
}

.v {
  color: #303133;
  font-weight: 400;
}

.copy-btn {
  padding: 0;
}
</style>
